/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Payout admin
 * Payout application
 * OpenAPI spec version: 1.0
 */

/**
 * Currency enumerates supported fiat and crypto currencies.
 *
 * Fiat currencies are based on ISO 4217:
 * https://github.com/datasets/currency-codes/blob/main/data/codes-all.csv
 *
 * Crypto currencies include a selected subset, expanded as needed.
 *
 *  - CURRENCY_UNSPECIFIED: Default value. Should not be used explicitly.
 *  - CURRENCY_AED: United Arab Emirates Dirham
 *  - CURRENCY_AFN: Afghan Afghani
 *  - CURRENCY_ALL: Albanian Lek
 *  - CURRENCY_AMD: Armenian Dram
 *  - CURRENCY_ANG: Netherlands Antillean Guilder
 *  - CURRENCY_AOA: Angolan Kwanza
 *  - CURRENCY_ARS: Argentine Peso
 *  - CURRENCY_AUD: Australian Dollar
 *  - CURRENCY_AWG: Aruban Florin
 *  - CURRENCY_AZN: Azerbaijani Manat
 *  - CURRENCY_BAM: Bosnia and Herzegovina Convertible Mark
 *  - CURRENCY_BBD: Barbados Dollar
 *  - CURRENCY_BDT: Bangladeshi Taka
 *  - CURRENCY_BGN: Bulgarian Lev
 *  - CURRENCY_BHD: Bahraini Dinar
 *  - CURRENCY_BIF: Burundian Franc
 *  - CURRENCY_BMD: Bermudian Dollar
 *  - CURRENCY_BND: Brunei Dollar
 *  - CURRENCY_BOB: Bolivian Boliviano
 *  - CURRENCY_BRL: Brazilian Real
 *  - CURRENCY_BSD: Bahamian Dollar
 *  - CURRENCY_BTN: Bhutanese Ngultrum
 *  - CURRENCY_BWP: Botswana Pula
 *  - CURRENCY_BYN: Belarusian Ruble
 *  - CURRENCY_BZD: Belize Dollar
 *  - CURRENCY_CAD: Canadian Dollar
 *  - CURRENCY_CDF: Congolese Franc
 *  - CURRENCY_CHF: Swiss Franc
 *  - CURRENCY_CLP: Chilean Peso
 *  - CURRENCY_CNY: Chinese Yuan Renminbi
 *  - CURRENCY_COP: Colombian Peso
 *  - CURRENCY_CRC: Costa Rican Colon
 *  - CURRENCY_CUP: Cuban Peso
 *  - CURRENCY_CVE: Cape Verde Escudo
 *  - CURRENCY_CZK: Czech Koruna
 *  - CURRENCY_DJF: Djiboutian Franc
 *  - CURRENCY_DKK: Danish Krone
 *  - CURRENCY_DOP: Dominican Peso
 *  - CURRENCY_DZD: Algerian Dinar
 *  - CURRENCY_EGP: Egyptian Pound
 *  - CURRENCY_ERN: Eritrean Nakfa
 *  - CURRENCY_ETB: Ethiopian Birr
 *  - CURRENCY_EUR: Euro
 *  - CURRENCY_FJD: Fiji Dollar
 *  - CURRENCY_FKP: Falkland Islands Pound
 *  - CURRENCY_GBP: Pound Sterling
 *  - CURRENCY_GEL: Georgian Lari
 *  - CURRENCY_GHS: Ghanaian Cedi
 *  - CURRENCY_GIP: Gibraltar Pound
 *  - CURRENCY_GMD: Gambian Dalasi
 *  - CURRENCY_GNF: Guinean Franc
 *  - CURRENCY_GTQ: Guatemalan Quetzal
 *  - CURRENCY_GYD: Guyanese Dollar
 *  - CURRENCY_HKD: Hong Kong Dollar
 *  - CURRENCY_HNL: Honduran Lempira
 *  - CURRENCY_HRK: Croatian Kuna (legacy)
 *  - CURRENCY_HTG: Haitian Gourde
 *  - CURRENCY_HUF: Hungarian Forint
 *  - CURRENCY_IDR: Indonesian Rupiah
 *  - CURRENCY_ILS: Israeli New Shekel
 *  - CURRENCY_INR: Indian Rupee
 *  - CURRENCY_IQD: Iraqi Dinar
 *  - CURRENCY_IRR: Iranian Rial
 *  - CURRENCY_ISK: Icelandic Krona
 *  - CURRENCY_JMD: Jamaican Dollar
 *  - CURRENCY_JOD: Jordanian Dinar
 *  - CURRENCY_JPY: Japanese Yen
 *  - CURRENCY_KES: Kenyan Shilling
 *  - CURRENCY_KGS: Kyrgyzstani Som
 *  - CURRENCY_KHR: Cambodian Riel
 *  - CURRENCY_KMF: Comorian Franc
 *  - CURRENCY_KPW: North Korean Won
 *  - CURRENCY_KRW: South Korean Won
 *  - CURRENCY_KWD: Kuwaiti Dinar
 *  - CURRENCY_KYD: Cayman Islands Dollar
 *  - CURRENCY_KZT: Kazakhstani Tenge
 *  - CURRENCY_LAK: Lao Kip
 *  - CURRENCY_LBP: Lebanese Pound
 *  - CURRENCY_LKR: Sri Lanka Rupee
 *  - CURRENCY_LRD: Liberian Dollar
 *  - CURRENCY_LSL: Lesotho Loti
 *  - CURRENCY_LYD: Libyan Dinar
 *  - CURRENCY_MAD: Moroccan Dirham
 *  - CURRENCY_MDL: Moldovan Leu
 *  - CURRENCY_MGA: Malagasy Ariary
 *  - CURRENCY_MKD: Macedonian Denar
 *  - CURRENCY_MMK: Myanmar Kyat
 *  - CURRENCY_MNT: Mongolian Tugrik
 *  - CURRENCY_MOP: Macanese Pataca
 *  - CURRENCY_MRU: Mauritanian Ouguiya
 *  - CURRENCY_MUR: Mauritian Rupee
 *  - CURRENCY_MVR: Maldivian Rufiyaa
 *  - CURRENCY_MWK: Malawian Kwacha
 *  - CURRENCY_MXN: Mexican Peso
 *  - CURRENCY_MYR: Malaysian Ringgit
 *  - CURRENCY_MZN: Mozambican Metical
 *  - CURRENCY_NAD: Namibian Dollar
 *  - CURRENCY_NGN: Nigerian Naira
 *  - CURRENCY_NIO: Nicaraguan Cordoba
 *  - CURRENCY_NOK: Norwegian Krone
 *  - CURRENCY_NPR: Nepalese Rupee
 *  - CURRENCY_NZD: New Zealand Dollar
 *  - CURRENCY_OMR: Omani Rial
 *  - CURRENCY_PAB: Panamanian Balboa
 *  - CURRENCY_PEN: Peruvian Sol
 *  - CURRENCY_PGK: Papua New Guinean Kina
 *  - CURRENCY_PHP: Philippine Peso
 *  - CURRENCY_PKR: Pakistani Rupee
 *  - CURRENCY_PLN: Polish Zloty
 *  - CURRENCY_PYG: Paraguayan Guarani
 *  - CURRENCY_QAR: Qatari Riyal
 *  - CURRENCY_RUB: Russian Ruble
 *  - CURRENCY_RON: Romanian Leu
 *  - CURRENCY_RSD: Serbian Dinar
 *  - CURRENCY_RWF: Rwandan Franc
 *  - CURRENCY_SAR: Saudi Riyal
 *  - CURRENCY_SBD: Solomon Islands Dollar
 *  - CURRENCY_SCR: Seychelles Rupee
 *  - CURRENCY_SDG: Sudanese Pound
 *  - CURRENCY_SEK: Swedish Krona
 *  - CURRENCY_SGD: Singapore Dollar
 *  - CURRENCY_SHP: Saint Helena Pound
 *  - CURRENCY_SLE: Sierra Leonean Leone
 *  - CURRENCY_SLL: Sierra Leonean Leone (old code)
 *  - CURRENCY_SOS: Somali Shilling
 *  - CURRENCY_SRD: Surinam Dollar
 *  - CURRENCY_SSP: South Sudanese Pound
 *  - CURRENCY_STN: São Tomé and Príncipe Dobra
 *  - CURRENCY_SVC: Salvadoran Colon
 *  - CURRENCY_SYP: Syrian Pound
 *  - CURRENCY_SZL: Eswatini Lilangeni
 *  - CURRENCY_THB: Thai Baht
 *  - CURRENCY_TJS: Tajikistani Somoni
 *  - CURRENCY_TMT: Turkmenistani Manat
 *  - CURRENCY_TND: Tunisian Dinar
 *  - CURRENCY_TOP: Tongan Paʻanga
 *  - CURRENCY_TRY: Turkish Lira
 *  - CURRENCY_TTD: Trinidad and Tobago Dollar
 *  - CURRENCY_TWD: New Taiwan Dollar
 *  - CURRENCY_TZS: Tanzanian Shilling
 *  - CURRENCY_UAH: Ukrainian Hryvnia
 *  - CURRENCY_UGX: Ugandan Shilling
 *  - CURRENCY_USD: United States Dollar
 *  - CURRENCY_UYU: Uruguayan Peso
 *  - CURRENCY_UZS: Uzbekistani Som
 *  - CURRENCY_VES: Venezuelan Bolívar
 *  - CURRENCY_VND: Vietnamese Dong
 *  - CURRENCY_VUV: Vanuatu Vatu
 *  - CURRENCY_WST: Samoan Tala
 *  - CURRENCY_XAF: CFA Franc BEAC
 *  - CURRENCY_XCD: East Caribbean Dollar
 *  - CURRENCY_XOF: CFA Franc BCEAO
 *  - CURRENCY_XPF: CFP Franc (Pacific Franc)
 *  - CURRENCY_YER: Yemeni Rial
 *  - CURRENCY_ZAR: South African Rand
 *  - CURRENCY_ZMW: Zambian Kwacha
 *  - CURRENCY_ZWL: Zimbabwean Dollar
 *  - CURRENCY_TETHER: USDT
 *
 * Tether (USDT)
 */
export enum UniteTypeCurrency {
    CURRENCY_UNSPECIFIED = 'CURRENCY_UNSPECIFIED',
    CURRENCY_AED = 'CURRENCY_AED',
    CURRENCY_AFN = 'CURRENCY_AFN',
    CURRENCY_ALL = 'CURRENCY_ALL',
    CURRENCY_AMD = 'CURRENCY_AMD',
    CURRENCY_ANG = 'CURRENCY_ANG',
    CURRENCY_AOA = 'CURRENCY_AOA',
    CURRENCY_ARS = 'CURRENCY_ARS',
    CURRENCY_AUD = 'CURRENCY_AUD',
    CURRENCY_AWG = 'CURRENCY_AWG',
    CURRENCY_AZN = 'CURRENCY_AZN',
    CURRENCY_BAM = 'CURRENCY_BAM',
    CURRENCY_BBD = 'CURRENCY_BBD',
    CURRENCY_BDT = 'CURRENCY_BDT',
    CURRENCY_BGN = 'CURRENCY_BGN',
    CURRENCY_BHD = 'CURRENCY_BHD',
    CURRENCY_BIF = 'CURRENCY_BIF',
    CURRENCY_BMD = 'CURRENCY_BMD',
    CURRENCY_BND = 'CURRENCY_BND',
    CURRENCY_BOB = 'CURRENCY_BOB',
    CURRENCY_BRL = 'CURRENCY_BRL',
    CURRENCY_BSD = 'CURRENCY_BSD',
    CURRENCY_BTN = 'CURRENCY_BTN',
    CURRENCY_BWP = 'CURRENCY_BWP',
    CURRENCY_BYN = 'CURRENCY_BYN',
    CURRENCY_BZD = 'CURRENCY_BZD',
    CURRENCY_CAD = 'CURRENCY_CAD',
    CURRENCY_CDF = 'CURRENCY_CDF',
    CURRENCY_CHF = 'CURRENCY_CHF',
    CURRENCY_CLP = 'CURRENCY_CLP',
    CURRENCY_CNY = 'CURRENCY_CNY',
    CURRENCY_COP = 'CURRENCY_COP',
    CURRENCY_CRC = 'CURRENCY_CRC',
    CURRENCY_CUP = 'CURRENCY_CUP',
    CURRENCY_CVE = 'CURRENCY_CVE',
    CURRENCY_CZK = 'CURRENCY_CZK',
    CURRENCY_DJF = 'CURRENCY_DJF',
    CURRENCY_DKK = 'CURRENCY_DKK',
    CURRENCY_DOP = 'CURRENCY_DOP',
    CURRENCY_DZD = 'CURRENCY_DZD',
    CURRENCY_EGP = 'CURRENCY_EGP',
    CURRENCY_ERN = 'CURRENCY_ERN',
    CURRENCY_ETB = 'CURRENCY_ETB',
    CURRENCY_EUR = 'CURRENCY_EUR',
    CURRENCY_FJD = 'CURRENCY_FJD',
    CURRENCY_FKP = 'CURRENCY_FKP',
    CURRENCY_GBP = 'CURRENCY_GBP',
    CURRENCY_GEL = 'CURRENCY_GEL',
    CURRENCY_GHS = 'CURRENCY_GHS',
    CURRENCY_GIP = 'CURRENCY_GIP',
    CURRENCY_GMD = 'CURRENCY_GMD',
    CURRENCY_GNF = 'CURRENCY_GNF',
    CURRENCY_GTQ = 'CURRENCY_GTQ',
    CURRENCY_GYD = 'CURRENCY_GYD',
    CURRENCY_HKD = 'CURRENCY_HKD',
    CURRENCY_HNL = 'CURRENCY_HNL',
    CURRENCY_HRK = 'CURRENCY_HRK',
    CURRENCY_HTG = 'CURRENCY_HTG',
    CURRENCY_HUF = 'CURRENCY_HUF',
    CURRENCY_IDR = 'CURRENCY_IDR',
    CURRENCY_ILS = 'CURRENCY_ILS',
    CURRENCY_INR = 'CURRENCY_INR',
    CURRENCY_IQD = 'CURRENCY_IQD',
    CURRENCY_IRR = 'CURRENCY_IRR',
    CURRENCY_ISK = 'CURRENCY_ISK',
    CURRENCY_JMD = 'CURRENCY_JMD',
    CURRENCY_JOD = 'CURRENCY_JOD',
    CURRENCY_JPY = 'CURRENCY_JPY',
    CURRENCY_KES = 'CURRENCY_KES',
    CURRENCY_KGS = 'CURRENCY_KGS',
    CURRENCY_KHR = 'CURRENCY_KHR',
    CURRENCY_KMF = 'CURRENCY_KMF',
    CURRENCY_KPW = 'CURRENCY_KPW',
    CURRENCY_KRW = 'CURRENCY_KRW',
    CURRENCY_KWD = 'CURRENCY_KWD',
    CURRENCY_KYD = 'CURRENCY_KYD',
    CURRENCY_KZT = 'CURRENCY_KZT',
    CURRENCY_LAK = 'CURRENCY_LAK',
    CURRENCY_LBP = 'CURRENCY_LBP',
    CURRENCY_LKR = 'CURRENCY_LKR',
    CURRENCY_LRD = 'CURRENCY_LRD',
    CURRENCY_LSL = 'CURRENCY_LSL',
    CURRENCY_LYD = 'CURRENCY_LYD',
    CURRENCY_MAD = 'CURRENCY_MAD',
    CURRENCY_MDL = 'CURRENCY_MDL',
    CURRENCY_MGA = 'CURRENCY_MGA',
    CURRENCY_MKD = 'CURRENCY_MKD',
    CURRENCY_MMK = 'CURRENCY_MMK',
    CURRENCY_MNT = 'CURRENCY_MNT',
    CURRENCY_MOP = 'CURRENCY_MOP',
    CURRENCY_MRU = 'CURRENCY_MRU',
    CURRENCY_MUR = 'CURRENCY_MUR',
    CURRENCY_MVR = 'CURRENCY_MVR',
    CURRENCY_MWK = 'CURRENCY_MWK',
    CURRENCY_MXN = 'CURRENCY_MXN',
    CURRENCY_MYR = 'CURRENCY_MYR',
    CURRENCY_MZN = 'CURRENCY_MZN',
    CURRENCY_NAD = 'CURRENCY_NAD',
    CURRENCY_NGN = 'CURRENCY_NGN',
    CURRENCY_NIO = 'CURRENCY_NIO',
    CURRENCY_NOK = 'CURRENCY_NOK',
    CURRENCY_NPR = 'CURRENCY_NPR',
    CURRENCY_NZD = 'CURRENCY_NZD',
    CURRENCY_OMR = 'CURRENCY_OMR',
    CURRENCY_PAB = 'CURRENCY_PAB',
    CURRENCY_PEN = 'CURRENCY_PEN',
    CURRENCY_PGK = 'CURRENCY_PGK',
    CURRENCY_PHP = 'CURRENCY_PHP',
    CURRENCY_PKR = 'CURRENCY_PKR',
    CURRENCY_PLN = 'CURRENCY_PLN',
    CURRENCY_PYG = 'CURRENCY_PYG',
    CURRENCY_QAR = 'CURRENCY_QAR',
    CURRENCY_RUB = 'CURRENCY_RUB',
    CURRENCY_RON = 'CURRENCY_RON',
    CURRENCY_RSD = 'CURRENCY_RSD',
    CURRENCY_RWF = 'CURRENCY_RWF',
    CURRENCY_SAR = 'CURRENCY_SAR',
    CURRENCY_SBD = 'CURRENCY_SBD',
    CURRENCY_SCR = 'CURRENCY_SCR',
    CURRENCY_SDG = 'CURRENCY_SDG',
    CURRENCY_SEK = 'CURRENCY_SEK',
    CURRENCY_SGD = 'CURRENCY_SGD',
    CURRENCY_SHP = 'CURRENCY_SHP',
    CURRENCY_SLE = 'CURRENCY_SLE',
    CURRENCY_SLL = 'CURRENCY_SLL',
    CURRENCY_SOS = 'CURRENCY_SOS',
    CURRENCY_SRD = 'CURRENCY_SRD',
    CURRENCY_SSP = 'CURRENCY_SSP',
    CURRENCY_STN = 'CURRENCY_STN',
    CURRENCY_SVC = 'CURRENCY_SVC',
    CURRENCY_SYP = 'CURRENCY_SYP',
    CURRENCY_SZL = 'CURRENCY_SZL',
    CURRENCY_THB = 'CURRENCY_THB',
    CURRENCY_TJS = 'CURRENCY_TJS',
    CURRENCY_TMT = 'CURRENCY_TMT',
    CURRENCY_TND = 'CURRENCY_TND',
    CURRENCY_TOP = 'CURRENCY_TOP',
    CURRENCY_TRY = 'CURRENCY_TRY',
    CURRENCY_TTD = 'CURRENCY_TTD',
    CURRENCY_TWD = 'CURRENCY_TWD',
    CURRENCY_TZS = 'CURRENCY_TZS',
    CURRENCY_UAH = 'CURRENCY_UAH',
    CURRENCY_UGX = 'CURRENCY_UGX',
    CURRENCY_USD = 'CURRENCY_USD',
    CURRENCY_UYU = 'CURRENCY_UYU',
    CURRENCY_UZS = 'CURRENCY_UZS',
    CURRENCY_VES = 'CURRENCY_VES',
    CURRENCY_VND = 'CURRENCY_VND',
    CURRENCY_VUV = 'CURRENCY_VUV',
    CURRENCY_WST = 'CURRENCY_WST',
    CURRENCY_XAF = 'CURRENCY_XAF',
    CURRENCY_XCD = 'CURRENCY_XCD',
    CURRENCY_XOF = 'CURRENCY_XOF',
    CURRENCY_XPF = 'CURRENCY_XPF',
    CURRENCY_YER = 'CURRENCY_YER',
    CURRENCY_ZAR = 'CURRENCY_ZAR',
    CURRENCY_ZMW = 'CURRENCY_ZMW',
    CURRENCY_ZWL = 'CURRENCY_ZWL',
    CURRENCY_TETHER = 'CURRENCY_TETHER',
}
